export const formatTimeFromMS = (time: string): string => {
  const milliseconds = parseInt(time, 10);
  const seconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60);

  return `${minutes % 60}:${seconds % 60}:${milliseconds % 1000}`;
};
